import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Injectable } from '@angular/core';

@Injectable()
export class TableViewService {
  public onCdkDrop<T>(data: T[], previousIndex: number, currentIndex: number): T[] {
    const partitions = this.partitionArrayForDraggable(data);
    moveItemInArray(partitions[0], previousIndex, currentIndex);
    partitions[1].forEach((index) => partitions[0].splice(index, 0, index));
    return partitions[0].map((index) => data[index]);
  }

  private partitionArrayForDraggable(array: any[]): number[][] {
    const partitions = [[], []];
    array.forEach((item, index) => {
      if (item.draggable === false) {
        partitions[1].push(index);
      } else {
        partitions[0].push(index);
      }
    });
    return partitions;
  }
}
